import {HTMLAttributes} from 'react'
import {ButtonNavLinkProps} from '@/components/ui/button-nav-link/ButtonNavLink'
import {StyledTab, StyledTabs, StyledTabWarning} from './style'

export const Tabs = ({paddingX, ...props}: HTMLAttributes<HTMLDivElement> & {paddingX?: number}) => (
    <StyledTabs {...props} $paddingX={paddingX} />
)
export const Tab = (props: Omit<ButtonNavLinkProps, 'variant'>) => <StyledTab variant="ghost" {...props} />
export const TabWarning = (props: HTMLAttributes<HTMLSpanElement>) => <StyledTabWarning {...props} />
